module.exports = __webpack_public_path__ + "assets/img/block-69fdbf23.png";